// extracted by mini-css-extract-plugin
module.exports = {"product-bundles":"Bundles_product-bundles__kNGDF"};